import { Component, OnInit, Inject, ViewChild, ElementRef, NgZone, Renderer2, RendererFactory2 } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { MenuItem, MessageService } from "primeng/api";
import { AuthService } from "./providers/auth.service";
import { ConnectionService } from 'ng-connection-service';
import { BehaviorSubject, Subject } from 'rxjs';
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "src/environments/environment";
import { Clipboard } from '@angular/cdk/clipboard';
import { CommonService } from "./providers/common.service";
import { Router } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { BlinkHandoffService } from "./core/services/blink-handoff.service";
const MINUTES_UNITL_AUTO_LOGOUT = environment.autoLogoutTime ;
const CHECK_INTERVALL = environment.checkInterval; 
const STORE_KEY = 'lastAction';
const excludedPaths = [
  '/auth/forgot-password', 
  '/userVerify', 
  '/auth/mfa',
  '/auth/totp/setup',
  '/auth/totp/verify',
];

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [MessageService],
})
export class AppComponent implements OnInit {
  isConnected = true;  
  noInternetConnection: boolean;
  timeoutId;
  userInactive: Subject<any> = new Subject();
  automaticLogOut: Subject<any> = new Subject();
  logOutFlag = false;
  idleState = 'Not started.';
  timedOut = false;
  logoutTimer;
  @ViewChild('logOutModal') logOutModal: ElementRef;
  modalReference: NgbModalRef;
  count = 30;  
  isPopupOpen = false ;
  reloadFlag = false;
  currentAppVersion = null;
  items: MenuItem[];
  @ViewChild('example') currenActiveElement: any;
  whitelabelResData :any
  domainName = window.location.origin
  baseUrl = environment.apiUrl;
  imageUrl = environment.whitelabelLogoPath;
  private renderer: Renderer2;
  isLoading = true
  public dataSubject = new Subject<any>();


  constructor(@Inject(DOCUMENT) private document: Document,private title: Title, private authService:AuthService ,private connectionService: ConnectionService, 
    private messageService: MessageService, private ngbModal: NgbModal, private ngZone: NgZone,
    private clipboard: Clipboard, private router: Router, public commonService: CommonService,private rendererFactory: RendererFactory2,_blinkHandoff: BlinkHandoffService
  ) {

    this.check();
    this.initListener();
    this.initInterval();      
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  ngOnInit(): void {
    this.items = [
      {
        label: 'Copy',
        icon: 'pi pi-copy',
        disabled: true,
        command: (event) => {
          const copiedText = window.getSelection().toString();
          this.clipboard.copy(copiedText);
          this.messageService.clear()
          const isMacBrowser = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
          let detail = `Use ${isMacBrowser ? 'CMD' : 'CTRL'} + V to paste`
          this.messageService.add({ severity: 'info', summary: 'Copied to clipboard', detail, key: 'copy-toast' });

        }
      }
    ]
    this.setDefaultTheme();
    this.checkConnection();
    window.onbeforeunload = () => {
      this.reloadFlag = true;
      this.reset();
      this.reloadFlag = false;
    }; 
    if(!environment.inspect){
      this.preventInspect();
    }
    window.addEventListener('storage', (event) => {
      if (event.storageArea !== localStorage) return;

      if (event.key === 'current_user') {
        this.ngZone.run(() => {
          try {
            const prev = event.oldValue ? JSON.parse(event.oldValue) : null;
            const next = event.newValue ? JSON.parse(event.newValue) : null;
            if (!prev?.accessToken) return;
            const identity = (u: { id?: unknown; email?: string }) =>
              `${String(u?.id ?? '')}|${String(u?.email ?? '').toLowerCase()}`;
            if (identity(prev) !== identity(next ?? {})) {
              this.authService.notifyDejaupWindowsLogout();
            }
          } catch {
            /* ignore */
          }
        });
        return;
      }

      let token = localStorage.getItem('logger_token');
      if (token == undefined && !window.location.href.includes('/auth/terms-condition') && !window.location.href.includes('/terms-condition')) {
        let curentPath = window.location.pathname;
        if (!excludedPaths.includes(curentPath) &&
        (!curentPath.includes('view-receipt') && !curentPath.includes('view-invoice')) ) {
          this.router.navigate(["/auth/login"]);
        }
      }
    });
    this.setTitleAndFaviconFromStorage()
  }

  setTitleAndFaviconFromStorage(): void {
    setTimeout(()=>{
      this.isLoading = false;
    },300)
    const localWhitelabelData = JSON.parse(localStorage.getItem('whitelabelResData'));
    let storedTitle 
    let storedFavicon

    if (localWhitelabelData) {
      storedTitle = localWhitelabelData.tabName;
      storedFavicon = `${this.imageUrl}/${localWhitelabelData.favicon}`;
    } else {
     storedTitle = 'IPOSpays';
     storedFavicon = environment.defaultIcon;
    }
    this.setTitleAndFavicon(storedTitle, storedFavicon);
  }


  // Method to set title and favicon dynamically
  setTitleAndFavicon(newTitle: string, iconImage: string): void {
    const titleElement = document.getElementById('dynamicTitle');
    let iconElement = document.getElementById('dynamicFavicon');
    // Set the title dynamically
    if (titleElement) {
      this.renderer.setProperty(titleElement, 'innerText', newTitle);
      document.title = newTitle;  
    }    
    if (iconElement) {
      this.renderer.setProperty(iconElement, 'href', iconImage);
    } 
    localStorage.setItem('customTitle', newTitle);
    localStorage.setItem('customFavicon', iconImage);
  }

  onShowContextMenu() {
    const copiedText = window.getSelection().toString();
    if (copiedText) this.items[0].disabled = false
    else this.items[0].disabled = true

  }

  showToaster(type, define, message, myToast) {
    this.messageService.add({
      severity: type,
      summary: define,
      key : myToast,
      detail: message,
    });
  }

  preventInspect(){
    document.addEventListener('contextmenu', function(e) {
      e.preventDefault();
    });

    document.onkeydown = function(e) {
      if(e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
         return false;
      }
      if(e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
         return false;
      }
      if(e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
         return false;
      }
      if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
         return false;
      }
    }
  }

  setDefaultTheme() {

    let user=this.authService.getUser;
    if(user && ((user.themeColor == null)? "theme-purple-light" : user.themeColor)){
      this.document.body.classList.remove(
        "theme-purple-light",
        "theme-cyan-light",
        "theme-bluegrey-light"
      );
      this.document.body.classList.add(user.themeColor);
    }
    
  }
  checkConnection(){
    this.connectionService.monitor().subscribe(isConnected => {  
      this.isConnected = isConnected.hasInternetAccess;  
      if (this.isConnected) {  
        this.noInternetConnection=false;  
        this.showToaster('success', 'Back Online', '', 'myToast');
      }  
      else {
        this.noInternetConnection=true; 
        this.showToaster('warn', 'warning', 'No Connection', 'myToast');
      }  
    })
  }

  continueSession() {
    this.lastAction = Date.now();
    this.modalReference.close();
    clearTimeout(this.logoutTimer);
    this.isPopupOpen = false;
  }

  get lastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }
  set lastAction(value : number) {
    localStorage.setItem(STORE_KEY, value.toString());
  }

  reset() {
    if(this.isPopupOpen == false || (this.isPopupOpen == true && this.reloadFlag == true)){
      this.lastAction = Date.now();
    }
  }

  initListener() {
    this.ngZone.runOutsideAngular(() => {
      document.body.addEventListener('click', () => this.reset());
      document.body.addEventListener('mouseover',()=> this.reset());
      document.body.addEventListener('mouseout',() => this.reset());
      document.body.addEventListener('keydown',() => this.reset());
      document.body.addEventListener('keyup',() => this.reset());
      document.body.addEventListener('keypress',() => this.reset());
    });
  }

  initInterval() {
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        if(this.authService.getUser) {
          this.check();
        }
      }, CHECK_INTERVALL);
    })
  }

  startCountdown(){
      var timeOut = setInterval(() => {
        if (this.count >= 0) {
          this.count -= 1;
        } else {
          clearInterval(timeOut);
        }
    }, 1000);
    this.count = 30;
  }

  check() {    

    let defaulLogoutIdleTime = MINUTES_UNITL_AUTO_LOGOUT;
    if(this.authService.getUser?.email && environment?.environmentName == 'prod') {
      let denovoDomainUsers = this.authService.getUser?.email.split("@").pop();
      if(denovoDomainUsers == "denovosystem.com"){
        defaulLogoutIdleTime = 15;
      }
    }

    const now = Date.now();
    const timeleftForWarning = this.lastAction + defaulLogoutIdleTime * 60 * 1000 - 30000;
    const diff = timeleftForWarning - now;
    const isTimeout = diff < 0;
    const timeleftForLogout = this.lastAction + defaulLogoutIdleTime * 60 * 1000 ; 
    const differenceForLogout = timeleftForLogout - now;
    const isTimeoutForLogout = differenceForLogout < 0;

    this.ngZone.run(() => {

      if (isTimeout && this.authService.getUser) {
        if(this.isPopupOpen == false){
          this.modalReference = this.ngbModal.open(this.logOutModal, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false });
          this.startCountdown();
          this.isPopupOpen = true;
        }
      }
      if(isTimeoutForLogout && this.authService.getUser){
        this.authService.logout();
        this.modalReference.close();
        this.ngbModal.dismissAll();
        this.isPopupOpen = false;
      }

    });
  }
}
